export default __webpack_public_path__ + "static/media/greenTheme-boy.de76babb.svg";